module.exports = __webpack_public_path__ + "img/check_hover.0a027861.svg";